import { gql } from 'graphql-tag';

export const UPDATE_SUPPLIER_DETAILS = gql`
  mutation Id506be2411a0effae89ecbc890ee91b16(
    $companyId: ID!
    $supplierId: ID!
    $accountHolderName: String
    $primaryEmail: String
    $bankDetails: SupplierBankDetailsUpdate
    $legalDetails: SupplierLegalDetailsUpdate
  ) {
    __typename
  }
`;
